import Vue from 'vue';
import Router from 'vue-router';
import MainLayout from '../layouts/MainLayout.vue';
import Login from '../views/Login.vue';
import Workbench from '../views/Workbench.vue';
import { getToken } from '../utils/auth';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/workbench' },
    { path: '/login', component: Login },
    {
      path: '/',
      component: MainLayout,
      children: [{ path: 'workbench', component: Workbench }]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.path !== '/login' && !token) return next('/login');
  if (to.path === '/login' && token) return next('/workbench');
  return next();
});

export default router;

